var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("JonInfo", {
    scopedSlots: _vm._u([
      {
        key: "message",
        fn: function() {
          return [
            _c("p", { staticClass: "font-weight-extra-bold" }, [
              _vm._v(
                "\n\t\t\tJede Software, die du beherrscht, erhöht deine Chancen - daher erfasse alles!\n\t\t"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "\n\t\t\tZum Beispiel Programme für Grafik, Programmiersprachen, Buchhaltung, Musikbearbeitung, Konstruktion,\n\t\t\tDesign, Produktion, Logistik und alle anderen. - Zum Beispiel BMD, SAP FI, Adobe Premiere, AutoCAD,\n\t\t\tJava, AutoCad.\n\t\t"
              )
            ])
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }